var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"refer-select folder",style:(_vm.getStyleName(_vm.item))})
}
var staticRenderFns = []

export { render, staticRenderFns }